import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import StickerForm from './StickerForm';

const StickerAdd = () => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
    const event = useSelector(state => state.event);

    return (
		<div>
	    	<h1>{t('sticker.addtitle')}</h1>
            <p>{t('sticker.addsubtitle') + event.name[lang]}</p>
            <StickerForm event={event} sticker={null}/>
		</div>
	);
};

export default StickerAdd;
